import React, { useEffect, useRef, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import asscentsLogo from "../../assets/loginLogo.svg"
import "./topnav.css";
import menuIcon from "../../assets/menu.svg";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { useNavigate } from "react-router-dom";
import LogoutModal from "../modals/logoutModal";
import ChangeSaved from "../popups/ChangeSaved";
import ErrorPopup from "../popups/ErrorPopup";

const Topnav = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuOptionOpen, setMenuOptionOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [onSuccessShow, onSetSuccessShow] = useState(false);
  const [onSuccessMsg, onSetSuccessMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setMenuOptionOpen(false);
    }
  };

  useEffect(() => {
    if (menuOptionOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuOptionOpen]);

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc = () => {
    onSetSuccessShow(false);
    navigate("/");
  };
  const logoutSuccess = (data) => {
    console.log(data);
    onSetSuccessShow(true);
    const str = data.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    onSetSuccessMsg(str_modify);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const logoutError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <div className="header d-flex justify-content-between">
      <span
        onClick={() => setOpen(!open)}
        className={`d-inline-block d-lg-none mx-3 py-0`}
      >
        <img src={menuIcon} alt="" className="menuicon" />
      </span>
      <div className=" d-flex flex-row justify-content-center justify-content-lg-between align-items-center ms-0 ms-sm-4 ms-lg-0  w-100 p-2">
        <img
          src={asscentsLogo}
          alt="Asscents Logo"
          className="svgAsscents"
          onClick={() => {
            localStorage.setItem("activeTab", 1);
            navigate("/");
          }}
        />
      </div>
      <div className=" d-flex align-items-center justify-content-center p-3">
        <span className="mail-address fw_400 fs_14 d-none d-lg-block">
          {localStorage.getItem("email")}
        </span>
        <div ref={componentRef}>
          <button
            type="button"
            className="dots-button"
            onClick={() => {
              setMenuOptionOpen(!menuOptionOpen);
            }}
          >
            <BsThreeDotsVertical size={15} color="#262C3D" />
          </button>
          {menuOptionOpen && (
            <div className="position-relative">
              <div className="menu_option_contianer  py-2 px-5">
                <span
                  className=" fw_500 fs_14 text-left cursor_pointer"
                  onClick={() => setShowModal(true)}
                >
                  Logout
                </span>
              </div>
            </div>
          )}{" "}
        </div>
      </div>
      <LogoutModal
        logoutShow={showModal}
        handleLogoutClose={() => setShowModal(false)}
        logoutFunc={logoutHandler}
      />
      <ChangeSaved show={onSuccessShow} title={onSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};

export default Topnav;
